"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachLine3 = function SvgBeachLine3(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.099 3.099c1.275-1.275 3.826-1.275 8.926-1.275 5.101 0 7.652 0 8.927 1.275 1.275 1.275 1.275 3.826 1.275 8.926 0 10.202 0 10.202-10.202 10.202-5.1 0-7.65 0-8.926-1.275-1.275-1.275-1.275-3.826-1.275-8.927 0-5.1 0-7.65 1.275-8.926Zm14.675 11.182v-4.174h-2.041c-1.034 0-1.657.493-1.657 1.427 0 .648.312 1.083.87 1.271l-.96 1.476h1.107l.87-1.36h.762v1.36h1.05Zm-1.05-3.378v1.255h-.827c-.484 0-.788-.18-.788-.624 0-.45.32-.631.788-.631h.828Zm-5.711 1.443v-.902h2.378v.902h-2.378Zm-.695.303c0-.68-.32-1.156-.91-1.377.533-.205.804-.632.804-1.255 0-.902-.738-1.599-2.042-1.599-1.288 0-2.05.714-2.173 1.845h1.058c.098-.598.475-.967 1.107-.967.606 0 .967.32.967.811 0 .476-.279.78-.91.78h-.574v.877h.574c.68 0 1.009.311 1.009.836 0 .574-.378.927-1.058.927s-1.132-.386-1.206-1.124H5.907c.065 1.206.893 2.001 2.263 2.001 1.37 0 2.148-.713 2.148-1.755Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachLine3);
var _default = exports["default"] = Memo;